import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TrackHomeListContainer from "../../Containers/TrackHomeListContainer";
import TrackRecentContainer from "../../Containers/TrackRecentContainer";
import TracksOnThisDayContainer from "../../Containers/TracksOnThisDayContainer";
import TracksPopularLastWeekContainer from "../../Containers/TracksPopularLastWeekContainer";
import TrackHomeList from "./TrackHomeList";
import TracksRecent from "./TracksRecent";
import TracksPopularLastWeek from "~/Components/Elements/TracksPopularLastWeek";
import TracksOnThisDay from "~/Components/Elements/TracksOnThisDay";
import FeaturedPromoMixes from "./FeaturedPromoMixes";
import Kba from "../../Components/Elements/Kba";
import MediaProvider from "~/Components/library/MediaProvider";
import PlaylistRecentGrid from "../Playlists/PlaylistRecentGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refresh: false,
    };
  }
  checkRecent = () => {
    console.log("error checkRecent");
    this.setState({ refresh: true });
  };

  render() {
    const { refresh } = this.state;

    if (refresh) {
      this.setState({ refresh: false });
      return <Redirect to={`/`} />;
    }

    return (
      <MediaProvider>
        <div className="home-page-component">
          <Helmet>
            <title>Track of the Day | Dream Chimney</title>
          </Helmet>
          <div className="home-component">
            <TrackHomeListContainer render={(props) => <TrackHomeList checkRecent={this.checkRecent} {...props} />} />
            <Kba />
            <FeaturedPromoMixes />
            <TrackRecentContainer
              render={(props) => {
                return <TracksRecent {...props} />;
              }}
            />
            <Kba />
            <Row>
              <Col xs={12}>
                <h2 className="page-header">
                  <FontAwesomeIcon icon={faMusic} style={{ fontSize: 24, marginRight: 14 }} /> Recent Playlists
                </h2>
              </Col>
              <PlaylistRecentGrid limit={3} />
              <div className="playlist-recent-more">
                <Link to={`/playlists/recent`}>All Recent Playlists</Link>
              </div>
            </Row>
            <TracksPopularLastWeekContainer
              render={(props) => {
                return <TracksPopularLastWeek {...props} />;
              }}
            />
            <TracksOnThisDayContainer
              render={(props) => {
                return <TracksOnThisDay {...props} />;
              }}
            />
          </div>
        </div>
      </MediaProvider>
    );
  }
}

export default HomePage;
